module.exports = __webpack_public_path__ + "img/ING.f092650e.jpg";